import type { AvatarPreferences } from '@/types/avatar'

export const circleColors = [
  '#6fb8e0',
  '#D97757',
  '#8B6F5C',
  '#E8A87C',
  '#5C8A8A',
  '#C96B5C',
  '#B89878',
  '#7C9E9E',
  '#A67C52',
  '#6B8E8E',
  '#D88C66',
  '#9F7B5C',
  '#5A7878',
  '#43f7b4',
  '#f5d0c5',
  '#d1e8e4',
  '#f8d25c',
  '#ffafcc',
  '#cdb4db',
  '#bde0fe',
  '#a8dadc',
  '#ffd6a5',
  '#caffbf'
]

export const topTypes = [
  'NoHair',
  'Eyepatch',
  'Hat',
  'Hijab',
  'Turban',
  'WinterHat1',
  'WinterHat2',
  'WinterHat3',
  'WinterHat4',
  'LongHairBigHair',
  'LongHairBob',
  'LongHairBun',
  'LongHairCurly',
  'LongHairCurvy',
  'LongHairDreads',
  'LongHairFrida',
  'LongHairFro',
  'LongHairFroBand',
  'LongHairNotTooLong',
  'LongHairShavedSides',
  'LongHairMiaWallace',
  'LongHairStraight',
  'LongHairStraight2',
  'LongHairStraightStrand',
  'ShortHairDreads01',
  'ShortHairDreads02',
  'ShortHairFrizzle',
  'ShortHairShaggyMullet',
  'ShortHairShortCurly',
  'ShortHairShortFlat',
  'ShortHairShortRound',
  'ShortHairShortWaved',
  'ShortHairSides',
  'ShortHairTheCaesar',
  'ShortHairTheCaesarSidePart'
]

export const topColors = [
  'Black',
  'Blue01',
  'Blue02',
  'Blue03',
  'Gray01',
  'Gray02',
  'Heather',
  'PastelBlue',
  'PastelGreen',
  'PastelOrange',
  'PastelRed',
  'PastelYellow',
  'Pink',
  'Red',
  'White'
]

export const accessoriesTypes = [
  'Blank',
  'Kurt',
  'Prescription01',
  'Prescription02',
  'Round',
  'Sunglasses',
  'Wayfarers'
]

export const hairColors = [
  'Auburn',
  'Black',
  'Blonde',
  'BlondeGolden',
  'Brown',
  'BrownDark',
  'PastelPink',
  'Platinum',
  'Red',
  'SilverGray'
]

export const facialHairTypes = [
  'Blank',
  'BeardMedium',
  'BeardLight',
  'BeardMagestic',
  'MoustacheFancy',
  'MoustacheMagnum'
]

export const clotheTypes = [
  'BlazerShirt',
  'BlazerSweater',
  'CollarSweater',
  'GraphicShirt',
  'Hoodie',
  'Overall',
  'ShirtCrewNeck',
  'ShirtScoopNeck',
  'ShirtVNeck'
]

export const clotheColors = [
  'Black',
  'Blue01',
  'Blue02',
  'Blue03',
  'Gray01',
  'Gray02',
  'Heather',
  'PastelBlue',
  'PastelGreen',
  'PastelOrange',
  'PastelRed',
  'PastelYellow',
  'Pink',
  'Red',
  'White'
]

export const graphicTypes = [
  'Bat',
  'Basketball',
  'Baseball',
  'Club',
  'Cumbia',
  'Deer',
  'Diamond',
  'Football',
  'Heart',
  'Hola',
  'Hockey',
  'Pizza',
  'Resist',
  'SoccerBall',
  'Selena',
  'Spade',
  'Bear',
  'SkullOutline',
  'Skull',
  'TennisBall',
  'Trophy',
  'Volleyball'
]

export const eyeTypes = [
  'Close',
  'Cry',
  'Default',
  'Dizzy',
  'EyeRoll',
  'Happy',
  'Hearts',
  'Side',
  'Squint',
  'Surprised',
  'Wink',
  'WinkWacky'
]

export const eyebrowTypes = [
  'Angry',
  'AngryNatural',
  'Default',
  'DefaultNatural',
  'FlatNatural',
  'RaisedExcited',
  'RaisedExcitedNatural',
  'SadConcerned',
  'SadConcernedNatural',
  'UnibrowNatural',
  'UpDown',
  'UpDownNatural'
]

export const mouthTypes = [
  'Concerned',
  'Default',
  'Disbelief',
  'Eating',
  'Grimace',
  'Sad',
  'ScreamOpen',
  'Serious',
  'Smile',
  'Tongue',
  'Twinkle',
  'Vomit'
]

export const skinColors = [
  'Tanned',
  'Yellow',
  'Pale',
  'Light',
  'Brown',
  'DarkBrown',
  'Black'
]

export const topColorHexMap: Record<string, string> = {
  Black: '#262E33',
  Blue01: '#65C9FF',
  Blue02: '#5199E4',
  Blue03: '#25557C',
  Gray01: '#E6E6E6',
  Gray02: '#929598',
  Heather: '#3C4F5C',
  PastelBlue: '#B1E2FF',
  PastelGreen: '#A7FFC4',
  PastelOrange: '#FFDEB5',
  PastelRed: '#FFAFB9',
  PastelYellow: '#FFFFB1',
  Pink: '#FF488E',
  Red: '#FF5C5C',
  White: '#FFFFFF',
}

export const clotheColorHexMap: Record<string, string> = {
  ...topColorHexMap,
}

export const hairColorHexMap: Record<string, string> = {
  Auburn: '#A55728',
  Black: '#2C1B18',
  Blonde: '#B58143',
  BlondeGolden: '#D6B370',
  Brown: '#724133',
  BrownDark: '#4A312C',
  PastelPink: '#F59797',
  Platinum: '#ECDCBF',
  Red: '#C93305',
  SilverGray: '#E8E1E1',
}

export const skinColorHexMap: Record<string, string> = {
  Tanned: '#FD9841',
  Yellow: '#F8D25C',
  Pale: '#FFD9C4',
  Light: '#EDB98A',
  Brown: '#915B4A',
  DarkBrown: '#4A312C',
  Black: '#090806',
}

export interface AvatarPresetOption {
  id: string
  label: string
  description: string
  preferences: AvatarPreferences
}

function createAvatarPreset(overrides: Partial<AvatarPreferences>): AvatarPreferences {
  return {
    ...defaultAvatarPreferences(),
    ...overrides,
  }
}

export const avatarPresetOptions: AvatarPresetOption[] = [
  {
    id: 'classic-host',
    label: 'Classic Host',
    description: 'A polished game-night look with a relaxed hoodie.',
    preferences: createAvatarPreset({
      circleColor: '#6fb8e0',
      topType: 'ShortHairShortFlat',
      topColor: 'Black',
      accessoriesType: 'Round',
      hairColor: 'BrownDark',
      clotheType: 'Hoodie',
      clotheColor: 'Blue02',
      eyeType: 'Happy',
      mouthType: 'Smile',
    }),
  },
  {
    id: 'cozy-strategist',
    label: 'Cozy Strategist',
    description: 'Soft colors and a steady expression for late-night tables.',
    preferences: createAvatarPreset({
      circleColor: '#f5d0c5',
      topType: 'LongHairBun',
      hairColor: 'Auburn',
      clotheType: 'BlazerSweater',
      clotheColor: 'PastelRed',
      eyeType: 'Default',
      mouthType: 'Twinkle',
      skinColor: 'Light',
    }),
  },
  {
    id: 'retro-shades',
    label: 'Retro Shades',
    description: 'Bold glasses, a graphic tee, and confident energy.',
    preferences: createAvatarPreset({
      circleColor: '#bde0fe',
      topType: 'ShortHairShortRound',
      hairColor: 'Black',
      accessoriesType: 'Sunglasses',
      clotheType: 'GraphicShirt',
      clotheColor: 'PastelYellow',
      graphicType: 'Diamond',
      eyeType: 'Happy',
      eyebrowType: 'RaisedExcited',
      mouthType: 'Smile',
      skinColor: 'Brown',
    }),
  },
  {
    id: 'winter-captain',
    label: 'Winter Captain',
    description: 'Headwear-forward and ready to call trump.',
    preferences: createAvatarPreset({
      circleColor: '#d1e8e4',
      topType: 'WinterHat2',
      topColor: 'Heather',
      hairColor: 'Brown',
      clotheType: 'CollarSweater',
      clotheColor: 'Blue03',
      eyeType: 'Side',
      mouthType: 'Serious',
      skinColor: 'Tanned',
    }),
  },
  {
    id: 'bright-bidder',
    label: 'Bright Bidder',
    description: 'High-energy colors with a playful table presence.',
    preferences: createAvatarPreset({
      circleColor: '#caffbf',
      topType: 'LongHairCurly',
      hairColor: 'PastelPink',
      clotheType: 'ShirtCrewNeck',
      clotheColor: 'PastelOrange',
      eyeType: 'Wink',
      mouthType: 'Smile',
      skinColor: 'Pale',
    }),
  },
  {
    id: 'sharp-suit',
    label: 'Sharp Suit',
    description: 'A dressed-up look for league play and serious partners.',
    preferences: createAvatarPreset({
      circleColor: '#ffd6a5',
      topType: 'ShortHairTheCaesarSidePart',
      hairColor: 'Black',
      facialHairType: 'BeardMedium',
      facialHairColor: 'Black',
      clotheType: 'BlazerShirt',
      clotheColor: 'Gray01',
      eyeType: 'Default',
      mouthType: 'Smile',
      skinColor: 'DarkBrown',
    }),
  },
  {
    id: 'creative-lead',
    label: 'Creative Lead',
    description: 'Expressive hair, brighter layers, and a friendly grin.',
    preferences: createAvatarPreset({
      circleColor: '#cdb4db',
      topType: 'LongHairFrida',
      hairColor: 'Red',
      accessoriesType: 'Prescription02',
      clotheType: 'Overall',
      clotheColor: 'PastelGreen',
      eyeType: 'Hearts',
      mouthType: 'Smile',
      skinColor: 'Light',
    }),
  },
  {
    id: 'street-smart',
    label: 'Street Smart',
    description: 'Casual, calm, and built for long tournament runs.',
    preferences: createAvatarPreset({
      circleColor: '#a8dadc',
      topType: 'ShortHairSides',
      hairColor: 'SilverGray',
      accessoriesType: 'Wayfarers',
      clotheType: 'ShirtVNeck',
      clotheColor: 'Black',
      eyeType: 'Squint',
      mouthType: 'Serious',
      skinColor: 'Black',
    }),
  },
]

export function defaultAvatarPreferences(): AvatarPreferences {
  return {
    isCircle: true,
    circleColor: '#6fb8e0',
    topType: 'ShortHairShortFlat',
    topColor: 'Black',
    accessoriesType: 'Blank',
    hairColor: 'BrownDark',
    facialHairType: 'Blank',
    facialHairColor: 'BrownDark',
    clotheType: 'BlazerShirt',
    clotheColor: 'Blue01',
    graphicType: 'Bat',
    eyeType: 'Happy',
    eyebrowType: 'Default',
    mouthType: 'Smile',
    skinColor: 'Light'
  }
}

type RandomNumberGenerator = () => number

function pickRandom<T>(values: readonly T[], rng: RandomNumberGenerator): T {
  if (values.length === 0) {
    throw new Error('Cannot pick from an empty array')
  }

  const index = Math.floor(rng() * values.length)
  return values[Math.min(index, values.length - 1)]
}

function maybePick<T>(values: readonly T[], rng: RandomNumberGenerator, probability: number): T | undefined {
  return rng() < probability ? pickRandom(values, rng) : undefined
}

export interface RandomAvatarPreferencesOptions {
  rng?: RandomNumberGenerator
  enforceCircle?: boolean
  circlePalette?: readonly string[]
}

export function randomAvatarPreferences(options: RandomAvatarPreferencesOptions = {}): AvatarPreferences {
  const rng = options.rng ?? Math.random
  const palette = options.circlePalette ?? circleColors

  const topType = pickRandom(topTypes, rng)
  const clotheType = pickRandom(clotheTypes, rng)
  const facialHairType = pickRandom(facialHairTypes, rng)
  const hairColor = pickRandom(hairColors, rng)
  const facialHairColor = facialHairType === 'Blank' ? hairColor : pickRandom(hairColors, rng)
  const isCircle = options.enforceCircle ?? rng() < 0.85

  const accessories = maybePick(accessoriesTypes.filter((type) => type !== 'Blank'), rng, 0.4) ?? 'Blank'
  const chosenGraphic = clotheType === 'GraphicShirt' ? pickRandom(graphicTypes, rng) : 'Bat'

  const avatar: AvatarPreferences = {
    isCircle,
    circleColor: pickRandom(palette, rng),
    topType,
    topColor: pickRandom(topColors, rng),
    accessoriesType: accessories,
    hairColor,
    facialHairType,
    facialHairColor,
    clotheType,
    clotheColor: pickRandom(clotheColors, rng),
    graphicType: chosenGraphic,
    eyeType: pickRandom(eyeTypes, rng),
    eyebrowType: pickRandom(eyebrowTypes, rng),
    mouthType: pickRandom(mouthTypes, rng),
    skinColor: pickRandom(skinColors, rng),
  }

  return avatar
}

export function formatAvatarLabel(value: string): string {
  if (!value) return ''
  return value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\d+/g, (match) => ` ${match}`)
    .replace(/_/g, ' ')
    .trim()
    .replace(/^./, (char) => char.toUpperCase())
}
